import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../common/service.base';
import { AppConfig } from '../configuration/app.config';
import { AuthService } from '../services/auth.service';
import { forEach } from '@angular/router/src/utils/collection';

class GetTranslationsRequest {
  language: string;
}

class GetTranslationsResponse {
  translations: any;
}

class TranslationEntry {
  match: string;
  replace: string;
  regex: RegExp;
}

@Injectable()
export class TranslationService extends RESTServiceBase {
  translations: TranslationEntry[] = [];

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'translation',
      authService,
      config.BFFSConfig
    );

    this.get('hu').then(trns => {
      for(let [k,v] of Object.entries(trns)) {
        this.translations.push({ match: k, replace: v, regex: new RegExp(k, 'gs')} as TranslationEntry);
      }
    });
  }

  public async get(language: string): Promise<any> {
    return (await super.get<GetTranslationsResponse>(undefined, { language } as GetTranslationsRequest, "")).translations;
  }

  public translate(text: string): string {
    if (!text) return text;

    for (let i = 0; i < this.translations.length; i++) {
      const trn = this.translations[i];
      if (trn.regex.test(text)) {
        text = text.replace(trn.regex, trn.replace);
      }
    }
    return text;
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/translation.service.ts